export default "__VITE_ASSET__BZrVPq6T__"